// Reducer for the VAT Period Export

import {
  VAT_INVOICE_LIST,
  VAT_INVOICE_LIST_SUCCESS,
  VAT_INVOICE_LIST_FAIL,
  VAT_INVOICE_ITEM_LIST,
  VAT_INVOICE_ITEM_LIST_SUCCESS,
  VAT_INVOICE_ITEM_LIST_FAIL,
  VAT_PURCHASE_LIST,
  VAT_PURCHASE_LIST_SUCCESS,
  VAT_PURCHASE_LIST_FAIL,
  VAT_PURCHASE_ITEM_LIST,
  VAT_PURCHASE_ITEM_LIST_SUCCESS,
  VAT_PURCHASE_ITEM_LIST_FAIL,
} from "./actionType";

const initialState = {
  vatInvoiceList: [],
  vatInvoiceListLoading: false,
  vatInvoiceItemList: [],
  vatInvoiceItemListLoading: false,
  vatPurchaseList: [],
  vatPurchaseListLoading: false,
  vatPurchaseItemList: [],
  vatPurchaseItemListLoading: false,
};

export default function VatPeriodExport(state = initialState, action) {
  switch (action.type) {
    // VAT Invoice List
    case VAT_INVOICE_LIST:
      return {
        ...state,
        vatInvoiceListLoading: true,
      };
    case VAT_INVOICE_LIST_SUCCESS:
      return {
        ...state,
        vatInvoiceList: action.data,
        vatInvoiceListLoading: false,
      };
    case VAT_INVOICE_LIST_FAIL:
      return {
        ...state,
        vatInvoiceListLoading: false,
      };

    // VAT Invoice Item List
    case VAT_INVOICE_ITEM_LIST:
      return {
        ...state,
        vatInvoiceItemListLoading: true,
      };
    case VAT_INVOICE_ITEM_LIST_SUCCESS:
      return {
        ...state,
        vatInvoiceItemList: action.data,
        vatInvoiceItemListLoading: false,
      };
    case VAT_INVOICE_ITEM_LIST_FAIL:
      return {
        ...state,
        vatInvoiceItemListLoading: false,
      };

    // VAT Purchase List
    case VAT_PURCHASE_LIST:
      return {
        ...state,
        vatPurchaseListLoading: true,
      };
    case VAT_PURCHASE_LIST_SUCCESS:
      return {
        ...state,
        vatPurchaseList: action.data,
        vatPurchaseListLoading: false,
      };
    case VAT_PURCHASE_LIST_FAIL:
      return {
        ...state,
        vatPurchaseListLoading: false,
      };

    // VAT Purchase Item List
    case VAT_PURCHASE_ITEM_LIST:
      return {
        ...state,
        vatPurchaseItemListLoading: true,
      };
    case VAT_PURCHASE_ITEM_LIST_SUCCESS:
      return {
        ...state,
        vatPurchaseItemList: action.data,
        vatPurchaseItemListLoading: false,
      };
    case VAT_PURCHASE_ITEM_LIST_FAIL:
      return {
        ...state,
        vatPurchaseItemListLoading: false,
      };

    default:
      return state;
  }
}
